import { render } from "./OrderEdit.vue?vue&type=template&id=49bcca88"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"

import "./OrderEdit.vue?vue&type=style&index=0&id=49bcca88&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__